import { Pipe, PipeTransform } from '@angular/core';
import { DecimalService } from '../services/decimal.service';
import {Observable} from 'rxjs';
import {Serializer} from '../interfaces/serializer';
import {User} from '../interfaces/user';
import {selectUser} from '../store/init/init.selectors';
import {Store} from '@ngrx/store';
import {AppState} from '../store/store';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'appnumber'
})
export class AppNumberPipe implements PipeTransform {
  private readonly _user$: Observable<Serializer<User>> = this._store.select(selectUser);

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _decimalS: DecimalService
  ) {}

  public transform(value: number): Observable<string> {
    return this._user$.pipe(
      map((user: Serializer<User>) => this._decimalS.format(user, value))
    );
  }

}
